import { ApiPropertyOptional } from '@nestjs/swagger';
import { IsBoolean, IsOptional, IsUUID } from 'class-validator';

export class ListLearningPathTeachingAssignmentsDto {
  @ApiPropertyOptional({ type: 'string', description: 'ID du Teaching' })
  @IsOptional()
  @IsUUID()
  teachingId?: string;

  @ApiPropertyOptional({ type: 'string', description: 'ID du parcours' })
  @IsOptional()
  @IsUUID()
  learningPathId?: string;

  @ApiPropertyOptional({ type: 'string', description: "ID de l'établissement" })
  @IsOptional()
  @IsUUID()
  establishmentId?: string;

  @ApiPropertyOptional({ type: 'string', description: "ID de l'année scolaire" })
  @IsOptional()
  @IsUUID()
  schoolYearId?: string;

  @ApiPropertyOptional({ type: Boolean, description: 'Visibilité' })
  @IsOptional()
  @IsBoolean()
  isVisible?: boolean;
}

